var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachmentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.281 4.91829C15.7352 4.32295 14.7497 4.28626 14.0928 4.94321L7.66104 11.375C7.49471 11.5413 7.49471 11.7532 7.66104 11.9195C7.82737 12.0858 8.03925 12.0858 8.20558 11.9195L13.5257 6.59942C13.8358 6.28932 14.3385 6.28932 14.6486 6.59942C14.9587 6.90951 14.9587 7.41227 14.6486 7.72237L9.32853 13.0425C8.54201 13.829 7.32461 13.829 6.53809 13.0425C5.75157 12.2559 5.75157 11.0385 6.53809 10.252L12.9698 3.82026C14.2145 2.57557 16.2372 2.53507 17.4399 3.83242C18.6724 5.07781 18.7087 7.09067 17.4165 8.28949L9.88436 15.8216C8.14499 17.561 5.4189 17.561 3.67953 15.8216C1.94016 14.0822 1.94016 11.3562 3.67953 9.61679L10.1113 3.18503C10.4214 2.87493 10.9241 2.87493 11.2342 3.18503C11.5443 3.49512 11.5443 3.99788 11.2342 4.30798L4.80248 10.7397C3.68329 11.8589 3.68329 13.5795 4.80248 14.6987C5.92166 15.8179 7.64223 15.8179 8.76141 14.6987L16.3048 7.15525C16.313 7.14712 16.3213 7.13916 16.3298 7.13139C16.9251 6.58566 16.9618 5.60016 16.3048 4.94321C16.2967 4.93508 16.2887 4.92677 16.281 4.91829Z",
    fill: "#21272F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachmentIcon);
export default __webpack_public_path__ + "static/media/attachmentIcon.d9ca0ef186ade5bafd634eee376d8fca.svg";
export { ForwardRef as ReactComponent };